const supportedCurrencies = [
  {
    name: "British Pound Sterling",
    value: "GBP",
  },
  {
    name: "Canadian Dollar",
    value: "CAD",
  },
  {
    name: "Central African CFA Franc",
    value: "XAF",
  },
  {
    name: "Chilean Peso",
    value: "CLP",
  },
  {
    name: "Colombian Peso",
    value: "COP",
  },
  {
    name: "Egyptian Pound",
    value: "EGP",
  },
  {
    name: "Single Euro Payments Area",
    value: "EUR",
  },
  {
    name: "Ghanaian Cedi",
    value: "GHS",
  },
  {
    name: "Guinean Franc",
    value: "GNF",
  },
  {
    name: "Kenyan Shilling",
    value: "KES",
  },
  {
    name: "Malawian Kwacha",
    value: "MWK",
  },
  {
    name: "Moroccan Dirham",
    value: "MAD",
  },
  {
    name: "Nigerian Naira",
    value: "NGN",
  },
  {
    name: "Rwandan Franc",
    value: "RWF",
  },
  {
    name: "Sierra Leonean Leone",
    value: "SLL",
  },
  {
    name: "São Tomé and Príncipe dobra",
    value: "STD",
  },
  {
    name: "South African Rand",
    value: "ZAR",
  },
  {
    name: "Tanzanian Shilling",
    value: "TZS",
  },
  {
    name: "Ugandan Shilling",
    value: "UGX",
  },
  {
    name: "United States Dollar",
    value: "USD",
  },
  {
    name: "West African CFA Franc BCEAO",
    value: "XOF",
  },
  {
    name: "Zambian Kwacha",
    value: "ZMW",
  },
  {
    name: "Indonesian Rupiah",
    value: "IDR",
  },
];

export default supportedCurrencies;
